import { create } from 'zustand';

interface NavigationState {
  isMobile: boolean;
  setIsMobile: (isMobile: boolean) => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  isMobile: window.innerWidth < 768,
  setIsMobile: (isMobile) => set({ isMobile }),
}));
